var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEligibleScholarships(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.982,
    height: 82.374,
    viewBox: "0 0 100.982 82.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.03)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.03)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.455 61.759)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.714,191.452a1.563,1.563,0,0,1,0-3.112H60.56v3.112H76.71Z",
    transform: "translate(-39.154 -187.253)",
    fill: "#ddf1fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.037,187.972a1.492,1.492,0,0,1,1.415-1.556H40.3V185.33H2.91a1.738,1.738,0,0,0-1.65,1.812v1.509a1.738,1.738,0,0,0,1.65,1.812H40.3v-.939H25.452a1.489,1.489,0,0,1-1.415-1.556Z",
    transform: "translate(-1.26 -185.33)",
    fill: "#912039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.05,190.473a1.738,1.738,0,0,1-1.65-1.812v-1.509a1.738,1.738,0,0,1,1.65-1.812h1.422a1.738,1.738,0,0,0-1.65,1.812v1.509a1.738,1.738,0,0,0,1.65,1.812H12.05Z",
    transform: "translate(-7.101 -185.336)",
    fill: "#ffcd52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.81,190.473a1.738,1.738,0,0,1-1.65-1.812v-1.509a1.738,1.738,0,0,1,1.65-1.812h1.422a1.738,1.738,0,0,0-1.65,1.812v1.509a1.738,1.738,0,0,0,1.65,1.812Z",
    transform: "translate(-31.23 -185.336)",
    fill: "#ffcd52"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.839 1.689)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.505,
    height: 0.412,
    transform: "translate(0 0.747)",
    fill: "#008ef8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.779,
    height: 0.412,
    transform: "translate(1.686)",
    fill: "#008ef8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.021,
    height: 0.412,
    transform: "translate(6.656 0.112)",
    fill: "#008ef8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.819,
    height: 0.412,
    transform: "translate(7.851 0.928)",
    fill: "#008ef8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.762,
    height: 0.412,
    transform: "translate(10.667 0.112)",
    fill: "#008ef8"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.407,177.182c-.5,0-.9-.7-.9-1.556s.4-1.556.9-1.556H65.13v3.112Z",
    transform: "translate(-51.51 -172.983)",
    fill: "#ddf1fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.893,173.7c0-.859.4-1.556.9-1.556h9.447V171.06H28.45c-.581,0-1.05.812-1.05,1.812v1.509c0,1,.469,1.812,1.05,1.812H52.242v-.939H42.8c-.5,0-.9-.7-.9-1.556Z",
    transform: "translate(-27.4 -171.06)",
    fill: "#b16de2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.807 2.437)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.137,
    height: 0.412,
    fill: "#008ef8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.159,
    height: 0.412,
    transform: "translate(4.992 0.18)",
    fill: "#008ef8"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.354,206.9a8.381,8.381,0,0,1-.148-1.646,7.164,7.164,0,0,1,.26-2.072H73.33V206.9H89.357Z",
    transform: "translate(-47.315 -201.873)",
    fill: "#ddf1fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8,204.585a8.381,8.381,0,0,1-.148-1.646,7.164,7.164,0,0,1,.26-2.072h17.07V199.56H1.7a12.355,12.355,0,0,0-.44,3.527,14.279,14.279,0,0,0,.253,2.8H44.977v-1.307H27.8Z",
    transform: "translate(-1.26 -199.56)",
    fill: "#ffcd52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.433,205.888a14.307,14.307,0,0,1-.253-2.8,12.355,12.355,0,0,1,.44-3.527h4.007a12.355,12.355,0,0,0-.44,3.527,14.279,14.279,0,0,0,.253,2.8Z",
    transform: "translate(-31.882 -199.56)",
    fill: "#ff9a78"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.362 1.964)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.133,
    height: 0.412,
    transform: "translate(0 0.996)",
    fill: "#008ef8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.133,
    height: 0.412,
    transform: "translate(1.776 2.05)",
    fill: "#008ef8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.133,
    height: 0.412,
    transform: "translate(6.599 2.05)",
    fill: "#008ef8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.263,
    height: 0.412,
    transform: "translate(8.465 1.137)",
    fill: "#008ef8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.263,
    height: 0.412,
    transform: "translate(11.288 2.05)",
    fill: "#008ef8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.942,
    height: 0.412,
    transform: "translate(8.313)",
    fill: "#008ef8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.942,
    height: 0.412,
    transform: "translate(10.053)",
    fill: "#008ef8"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.779,33.872a3.055,3.055,0,0,1,3.1-1.628l2.668.339.484-3.812-2.668-.339a3.048,3.048,0,0,1-2.6-2.35q-.119-.531-.282-1.04A3.052,3.052,0,0,1,71.53,21.69l2.126-1.646L71.3,17,69.176,18.65a3.06,3.06,0,0,1-3.509.17c-.3-.191-.614-.368-.935-.534a3.055,3.055,0,0,1-1.628-3.1l.339-2.668-3.812-.484L59.293,14.7a3.048,3.048,0,0,1-2.35,2.6q-.531.119-1.04.282a3.052,3.052,0,0,1-3.353-1.043L50.9,14.409l-3.039,2.354,1.646,2.126a3.06,3.06,0,0,1,.17,3.509c-.191.3-.372.614-.534.935a3.055,3.055,0,0,1-3.1,1.628l-2.668-.339-.484,3.812,2.668.339a3.048,3.048,0,0,1,2.6,2.35q.119.531.282,1.04a3.052,3.052,0,0,1-1.043,3.353l-2.126,1.646L47.622,40.2l2.126-1.646a3.06,3.06,0,0,1,3.509-.17c.3.191.614.368.935.534a3.055,3.055,0,0,1,1.628,3.1l-.339,2.668,3.812.484.339-2.668a3.048,3.048,0,0,1,2.35-2.6q.531-.119,1.04-.282a3.052,3.052,0,0,1,3.353,1.043L68.021,42.8l3.039-2.354-1.646-2.126a3.06,3.06,0,0,1-.17-3.509C69.436,34.5,69.613,34.194,69.779,33.872ZM58.553,35.753a7.209,7.209,0,1,1,8.061-6.241A7.206,7.206,0,0,1,58.553,35.753Z",
    transform: "translate(-42.89 -7.677)",
    fill: "#ddf1fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.508,13.492a2.422,2.422,0,0,1-1.982-1.96c-.051-.282-.112-.563-.188-.837a2.429,2.429,0,0,1,.946-2.628l1.747-1.231-1.762-2.5-1.747,1.231a2.42,2.42,0,0,1-2.79.011c-.235-.162-.477-.314-.726-.458A2.423,2.423,0,0,1,202.823,2.6L203.187.49l-3.011-.52-.365,2.108a2.422,2.422,0,0,1-1.96,1.982c-.282.051-.563.112-.837.188a2.429,2.429,0,0,1-2.628-.946l-1.231-1.747-2.5,1.762,1.231,1.747a2.42,2.42,0,0,1,.011,2.79c-.162.235-.314.476-.458.726a2.423,2.423,0,0,1-2.523,1.184L186.81,9.4l-.52,3.011,2.108.365a2.422,2.422,0,0,1,1.982,1.96c.051.282.112.563.188.837a2.429,2.429,0,0,1-.946,2.628l-1.747,1.231,1.762,2.5,1.747-1.231a2.42,2.42,0,0,1,2.79-.011c.235.162.476.314.726.458a2.423,2.423,0,0,1,1.184,2.523l-.365,2.108,3.011.52.365-2.108a2.422,2.422,0,0,1,1.96-1.982c.282-.051.563-.112.837-.188a2.429,2.429,0,0,1,2.628.946l1.231,1.747,2.5-1.762L207.017,21.2a2.42,2.42,0,0,1-.011-2.79c.162-.235.314-.476.458-.726a2.423,2.423,0,0,1,2.523-1.184l2.108.365.52-3.011-2.108-.365Zm-12.024,5.3a5.732,5.732,0,1,1,6.62-4.675,5.732,5.732,0,0,1-6.62,4.675Z",
    transform: "translate(-134.526 0.03)",
    fill: "#ddf1fa"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 100.982,
    height: 3.989,
    rx: 1.994,
    transform: "translate(100.982 82.374) rotate(180)",
    fill: "#ddf1fa"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.872 23.886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.773,108.1h44.356a4.549,4.549,0,0,0,4.6-4.953l-2.3-32.054a5.406,5.406,0,0,0-5.306-4.953H92.766a4.549,4.549,0,0,0-4.6,4.953l2.3,32.054a5.406,5.406,0,0,0,5.306,4.953Z",
    transform: "translate(-84.206 -66.14)",
    fill: "#008ef8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.823,66.25h3.956a4.549,4.549,0,0,0-4.6,4.953l2.3,32.054a5.409,5.409,0,0,0,5.35,4.913l-4,.04a5.4,5.4,0,0,1-5.306-4.953L77.227,71.2a4.549,4.549,0,0,1,4.6-4.953Z",
    transform: "translate(-77.215 -66.21)",
    fill: "#0234c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.577,182.38l1.047,10.429h-1.877L136.7,182.38Z",
    transform: "translate(-115.227 -140.42)",
    fill: "#0234c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.269,212.1h19.193a1.559,1.559,0,0,0,1.505-1.343l.007-.069a1.164,1.164,0,0,0-1.177-1.343H135.6a1.559,1.559,0,0,0-1.505,1.343l-.007.069A1.164,1.164,0,0,0,135.269,212.1Z",
    transform: "translate(-113.554 -157.655)",
    fill: "#0234c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.9,182.38h7.786l.74,7.342a2.634,2.634,0,0,0,2.7,2.4H142.878Z",
    transform: "translate(-118.55 -140.42)",
    fill: "#008ef8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.621,111.849h43.328L146.628,79.47H103.3Z",
    transform: "translate(-93.884 -74.658)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.775 45.859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.693,196.4h-.1v-.538H232.08v3.375a4.257,4.257,0,0,0,7.967,2.09h.646a2.464,2.464,0,0,0,0-4.927Zm0,4.321h-.365a4.289,4.289,0,0,0,.271-1.48v-2.231h.1a1.855,1.855,0,1,1,0,3.711Z",
    transform: "translate(-232.08 -171.008)",
    fill: "#f46534"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.024,149.88s-1.444.083-.7-1.808c.9-2.31,10.548-5.122,9.844-9.443s-7.133-1.408-6.028-4.62,2.689-5.324,1.094-6.631-9.234.877-8.88,7.082c.253,4.368,5.4,4.068,5.335,6.277s-5.241,4.62-4.259,6.931a3.891,3.891,0,0,0,3.6,2.209Z",
    transform: "translate(-233.337 -127.013)",
    fill: "#ddf1fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.291,131.605a1.6,1.6,0,1,1-1.6-1.6A1.6,1.6,0,0,1,265.291,131.605Z",
    transform: "translate(-251.717 -128.928)",
    fill: "#ddf1fa"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.235 28.887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.886,100.674q-6.227.964-12.428,2.484a90.372,90.372,0,0,1-.776-22.572q6.416-.13,12.746.285a77.893,77.893,0,0,0,.458,19.8Z",
    transform: "translate(-48.107 -80.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.123,104.692l-.036-.22a73.9,73.9,0,0,1-.635-18.464l.018-.184h.184c3.473-.072,6.978.007,10.414.231l.213.014-.022.213a63.316,63.316,0,0,0,.375,16.1l.032.2-.2.032c-3.379.523-6.786,1.206-10.122,2.025l-.217.054Zm-.278-18.464a73.509,73.509,0,0,0,.614,17.958c3.213-.783,6.487-1.437,9.739-1.946a63.745,63.745,0,0,1-.368-15.789C58.534,86.243,55.177,86.167,51.845,86.228Z",
    transform: "translate(-49.92 -83.703)",
    fill: "#ffcd52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,124.162l-.09-.4c1.642-.368,3.317-.668,4.974-.892l.054.4c-1.646.22-3.307.52-4.938.884Z",
    transform: "translate(-57.839 -107.393)",
    fill: "#ffcd52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.662,100.829l-.032-.408c2.779-.209,5.6-.3,8.357-.278v.412c-2.754-.025-5.555.069-8.324.278Z",
    transform: "translate(-52.145 -92.867)",
    fill: "#ffcd52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.942,106.247l-.032-.408c2.779-.209,5.591-.307,8.357-.278v.412c-2.754-.025-5.555.069-8.324.278Z",
    transform: "translate(-52.324 -96.329)",
    fill: "#ffcd52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1,103.005a.2.2,0,0,1-.112-.032.221.221,0,0,1-.09-.137,90.571,90.571,0,0,1-.776-22.622.209.209,0,0,1,.2-.188c4.256-.087,8.551.011,12.764.285a.194.194,0,0,1,.144.072.2.2,0,0,1,.047.155,77.788,77.788,0,0,0,.458,19.745.2.2,0,0,1-.17.235c-4.137.643-8.313,1.476-12.414,2.48a.244.244,0,0,1-.051.007ZM48.509,80.43a90.356,90.356,0,0,0,.754,22.117c3.974-.967,8.021-1.776,12.031-2.4A77.9,77.9,0,0,1,60.844,80.7c-4.072-.26-8.216-.354-12.331-.274Z",
    transform: "translate(-47.746 -79.995)",
    fill: "#912039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.881,137.579l-.466-.473-.6.3.4-2.422,1.061.18Z",
    transform: "translate(-65.686 -115.132)",
    fill: "#ffcd52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.125,137.128l.361-.556.643.162-.9-2.285-1,.4Z",
    transform: "translate(-67.865 -114.793)",
    fill: "#ffcd52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.706,128.594c.022.195-.177.379-.217.56s.065.437-.032.6-.361.2-.505.325-.2.39-.375.466-.4-.054-.6-.033-.4.195-.581.155-.3-.285-.466-.379-.433-.072-.56-.213-.076-.4-.155-.581-.307-.307-.328-.5.177-.379.217-.56-.065-.437.032-.6.361-.2.505-.325.2-.39.375-.466.4.054.6.032.4-.195.581-.155.3.285.466.379.433.072.56.213.076.4.155.581.307.307.328.5Z",
    transform: "translate(-64.45 -109.977)",
    fill: "#f46534"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.705 8.746)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 23.329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.624,120.389l-.011-.065-1.621-8.2-.022-.116-1.722-8.714-4.13-.484.365,2.278,1.043,6.458-1.52-.159,2.733,7.649-.025.007-4.44,1.065a.47.47,0,0,0-.3.271,8.6,8.6,0,0,0-.144,4.028c.011.108.025.217.04.328.126,1.029.332,2.166.6,3.35.96,4.216,2.422,7.479,3.274,7.288.235-.054.4-.375.487-.892l5.252-12.648a2.127,2.127,0,0,0,.159-.946,2.277,2.277,0,0,0-.018-.495Z",
    transform: "translate(-146.088 -97.763)",
    fill: "#0234c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.215,111.406l2.18-5.512-3.433-3.834-.848,2.141-4.776,12.067-.289-.17s-5.249-3.151-5.346-3.162a.148.148,0,0,0-.04,0c-.6,0-1.119,1.657-1.386,4.093a35.5,35.5,0,0,0-.188,3.732c0,4.321.7,7.83,1.574,7.83a.44.44,0,0,0,.264-.116.213.213,0,0,0,.036-.025c.007-.007.018-.014.025-.022.718-.617,8.263-7.111,8.36-7.357l4.736-5.184-.191-4.949-.675.476Z",
    transform: "translate(-100.333 -97.284)",
    fill: "#0234c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.12,128.84h19.139l-.906-22.77H145.9Z",
    transform: "translate(-120.801 -99.846)",
    fill: "#0234c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,97.3c-.025,2.079-4.451,3.729-9.891,3.678-.848-.007-1.675-.058-2.462-.141-.213-.025-.422-.051-.632-.083-3.917-.531-6.732-1.967-6.714-3.635.022-1.429,2.1-2.653,5.173-3.267.141-.029.282-.058.426-.083a23.586,23.586,0,0,1,4.3-.336c.711.007,1.4.047,2.061.1.541.051,1.065.116,1.567.2,3.639.581,6.191,1.967,6.173,3.563Z",
    transform: "translate(-122.833 -91.773)",
    fill: "#0234c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.8,92.691c0-1.6-2.534-2.982-6.173-3.563-.5-.087-1.025-.152-1.567-.2-.664-.054-1.354-.09-2.061-.1a24.275,24.275,0,0,0-4.3.336c-.144.025-.289.054-.426.083-2.844.57-4.841,1.664-5.133,2.96-1.188,3.96,4.934,11,4.934,11S166.8,95.027,166.8,92.691Z",
    transform: "translate(-122.633 -88.828)",
    fill: "#f46534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.983,93.738l-6.4,4.364-1.953-4.245c.141-.029.282-.058.426-.083a23.586,23.586,0,0,1,4.3-.336c.711.007,1.4.047,2.061.1.541.051,1.065.116,1.567.2Z",
    transform: "translate(-131.991 -91.773)",
    fill: "#ffa187"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.645)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.972 4.932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.62,126.748l-.04,0c-.6,0-1.119,1.657-1.386,4.093L98,128.1,96.31,127l2.1-3.317,1.715,1,3.5,2.072Z",
    transform: "translate(-96.221 -123.676)",
    fill: "#f46534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.293,123.991a.011.011,0,0,1,0,.007,6.009,6.009,0,0,1-.765,1.549A6.427,6.427,0,0,1,96.5,126.81l-.007.007c-.036.032-.079.061-.108.087-.123.087-.217.119-.271.083s-.061-.13-.032-.274c.011-.051.025-.112.043-.173,0,0,0-.007,0-.011a6.49,6.49,0,0,1,.733-1.411,5.8,5.8,0,0,1,1.123-1.35s0-.007.007-.007a.389.389,0,0,1,.253-.087c.058.029.079.18.047.314Z",
    transform: "translate(-96.064 -123.67)",
    fill: "#db5b2f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.163,116.457a.758.758,0,0,0-.942-.513l-.8.235c.025.44.061.881.094,1.321l.978-.076a.782.782,0,0,0,.155-.029.758.758,0,0,0,.513-.942Z",
    transform: "translate(-82.652 -113.781)",
    fill: "#ffa187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.991,119.548a.759.759,0,0,0-.852-.65l-1.509.206c.029.4.051.794.087,1.191l1.469.108c.051,0,.1,0,.159,0a.759.759,0,0,0,.65-.852Z",
    transform: "translate(-82.786 -115.685)",
    fill: "#ffa187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.44,115.055l-.025-.018-1.375-1.043a7.173,7.173,0,0,0-.292-.8c-.585-1.357-1.448-2.328-2.058-2.364l-1.574-.007c-.065-.014-.137-.022-.2-.036a4.378,4.378,0,0,1-.715-.227,1.635,1.635,0,0,1-.39-.227l-.3-.213a.629.629,0,0,0-.928.787,2.171,2.171,0,0,0,.92.946,5.759,5.759,0,0,0,.939.44c.249.09.5.17.747.242a2.923,2.923,0,0,0,.191,2.339,2.847,2.847,0,0,0,1.628,1.765l1.541,1.166.022.018.343.264.007-.007a6.428,6.428,0,0,0,1.025-1.263,5.945,5.945,0,0,0,.765-1.549l-.278-.213Z",
    transform: "translate(-79.521 -110.007)",
    fill: "#ffa187"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.789 22.616)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.415,155.5c.011.108.025.217.04.328l-2.574.581-1.967.448-.964-3.8,1.938-.545,3.671-1.032a8.6,8.6,0,0,0-.144,4.028Z",
    transform: "translate(-168.77 -151.48)",
    fill: "#f46534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.758,159.325a1.192,1.192,0,0,1-.029.307c-.022.072-.051.119-.1.13s-.094-.011-.155-.069a1.123,1.123,0,0,1-.173-.231c-.018-.029-.032-.058-.051-.09a7.367,7.367,0,0,1-.531-1.415,7.072,7.072,0,0,1-.267-1.444c0-.1,0-.191,0-.267a.591.591,0,0,1,.018-.126q.027-.146.1-.173t.173.087a1.15,1.15,0,0,1,.079.1,1.68,1.68,0,0,1,.148.249,6.908,6.908,0,0,1,.513,1.368,7.509,7.509,0,0,1,.271,1.455c0,.04,0,.079,0,.116Z",
    transform: "translate(-168.452 -154.333)",
    fill: "#db5b2f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.067,156.984a.38.38,0,0,1,.455-.282l1.873.444-.1-.025,1.8.087a.582.582,0,0,1,.155.025.757.757,0,0,1-.383,1.466l-1.743-.458-.1-.025-1.751-.8a.376.376,0,0,1-.209-.433Z",
    transform: "translate(-147.108 -154.811)",
    fill: "#ffa187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.1,161.958a.382.382,0,0,1,.466-.271l1.354.361-.087-.029,1.267.1a.81.81,0,0,1,.22.051.761.761,0,1,1-.563,1.415l-1.18-.473-.087-.029-1.209-.708a.382.382,0,0,1-.177-.426Z",
    transform: "translate(-146.493 -157.995)",
    fill: "#ffa187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.075,163.953a.378.378,0,0,1,.473-.253l1.094.336h1.325a.775.775,0,0,1,.253.043.765.765,0,0,1-.505,1.444l-1.249-.437-.126-.04-1.094-.657a.379.379,0,0,1-.166-.437Z",
    transform: "translate(-147.109 -159.278)",
    fill: "#ffa187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.273,159.6a.9.9,0,0,0-.137-.022l-1.985-.119.094.022-2.108-.5a.38.38,0,0,0-.455.282.376.376,0,0,0,.217.433l1.985.866.094.022,1.928.48a.757.757,0,0,0,.365-1.469Z",
    transform: "translate(-145.582 -156.268)",
    fill: "#ffa187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.606,158.2c0-.036,0-.072,0-.116a7.463,7.463,0,0,0-.271-1.455,6.821,6.821,0,0,0-.513-1.368,1.676,1.676,0,0,0-.148-.249l-.365.116-.545.177c-.144-.076-.285-.152-.437-.227a7.631,7.631,0,0,0-.7-.3,2.874,2.874,0,0,0-.466-.13c-.473-.022-.758.054-.993.018-.195-.029-.4-.072-.61-.119-.415-.1-.841-.213-1.253-.339h-.011a.5.5,0,0,0-.375.928c.411.209.816.408,1.245.592.213.09.43.18.664.264.119.04.238.079.375.112.079.014.2.2.339.368-1.834.484-3.151,1.5-2.953,2.271s1.87,1.022,3.725.538a7.906,7.906,0,0,0,1.278-.448l1.563-.48.455-.141Z",
    transform: "translate(-149.987 -153.203)",
    fill: "#ffa187"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.657,161.843h-.029l-1.931-.271a.152.152,0,0,1-.054-.014l-2.1-.942a.205.205,0,1,1,.166-.375l2.072.931,1.9.267a.2.2,0,0,1,.173.231.206.206,0,0,1-.2.177Z",
    transform: "translate(-145.424 -159.464)",
    fill: "#912039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.16,159.394h-.007l-1.022-.04a.1.1,0,0,1-.04-.007l-.1-.025-1.787-.812a.2.2,0,0,1-.1-.271.206.206,0,0,1,.271-.1l1.783.8,1.007.04a.208.208,0,0,1,.2.213A.2.2,0,0,1,152.16,159.394Z",
    transform: "translate(-147.765 -158.119)",
    fill: "#912039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.264,164.564a.215.215,0,0,1-.04,0l-1.834-.372a.288.288,0,0,1-.04-.018l-1.209-.708a.206.206,0,1,1,.209-.354l1.256.718,1.7.332a.206.206,0,0,1-.04.408Z",
    transform: "translate(-146.457 -161.29)",
    fill: "#912039"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.616,55.946c-.426,4.014-3.011,7.032-5.768,6.739s-4.649-3.787-4.223-7.8,3.011-7.032,5.768-6.739S165.041,51.932,164.616,55.946Z",
    transform: "translate(-149.707 -39.489)",
    fill: "#ffa187"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.45 18.467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.223,83.543l-4.7.794V75.36h4.7Z",
    transform: "translate(-164.52 -75.36)",
    fill: "#ffa187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.209,84.779a3.666,3.666,0,0,1-.689-.152v.863a3.5,3.5,0,0,0,.841.206,4.468,4.468,0,0,0,3.862-1.888V82.7A4.561,4.561,0,0,1,165.209,84.779Z",
    transform: "translate(-164.52 -80.05)",
    fill: "#ef485d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.947,73.071a.874.874,0,0,1-.83-.393.891.891,0,0,1,.162-.942,2.814,2.814,0,0,1,.964-.809.205.205,0,0,1,.195.361,2.359,2.359,0,0,0-.823.682c-.144.206-.195.4-.134.513s.253.184.5.177a2.376,2.376,0,0,0,1.025-.3.205.205,0,0,1,.195.361,2.793,2.793,0,0,1-1.209.35h-.043Z",
    transform: "translate(-153.208 -54.044)",
    fill: "#912336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,59.5c0,1.736.949,3.144,2.123,3.144s2.123-1.408,2.123-3.144-.949-3.144-2.123-3.144S177,57.768,177,59.5Z",
    transform: "translate(-164.045 -44.751)",
    fill: "#572902"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.374 15.721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.451,69.549a2.037,2.037,0,1,1-2.263-1.783A2.033,2.033,0,0,1,179.451,69.549Z",
    transform: "translate(-175.39 -67.751)",
    fill: "#ffa187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.3,72.544a.207.207,0,0,1-.09-.022l-1.2-.585a.206.206,0,0,1-.029-.354l1.043-.718a.205.205,0,0,1,.231.339l-.754.52.881.43a.206.206,0,0,1-.09.39Z",
    transform: "translate(-177.632 -69.719)",
    fill: "#912336"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.772 7.263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.31,49.315a4.024,4.024,0,0,0-3,.693,3.605,3.605,0,0,0-1.206,4.931,3.157,3.157,0,0,0,.6.635c.318-2.913,1.772-5.292,3.6-6.256Z",
    transform: "translate(-151.559 -47.475)",
    fill: "#572902"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.783,49.19a3.914,3.914,0,1,1-3.13-4.815A4.065,4.065,0,0,1,174.783,49.19Z",
    transform: "translate(-161.441 -44.321)",
    fill: "#572902"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.628,53.1c0,1.011-1.671,1.83-3.729,1.83s-3.729-.819-3.729-1.83,1.671-1.83,3.729-1.83S160.628,52.089,160.628,53.1Z",
    transform: "translate(-152.589 -48.762)",
    fill: "#572902"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M194.976,42.978a.213.213,0,0,1-.206-.217V40.307a.206.206,0,1,1,.412,0v2.455A.21.21,0,0,1,194.976,42.978Z",
    transform: "translate(-175.4 -34.354)",
    fill: "#008ef8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.638,56.261H192.83l.513-6.371h.783Z",
    transform: "translate(-174.16 -40.617)",
    fill: "#0234c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.84,48.172a.651.651,0,1,1-.65-.682A.668.668,0,0,1,194.84,48.172Z",
    transform: "translate(-174.614 -39.083)",
    fill: "#008ef8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.083,33.076,141.11,29.47l11.244-5.27L163.3,29.47Z",
    transform: "translate(-141.11 -24.2)",
    fill: "#0234c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.266,39.234c-.1-.758-2.707-1.364-5.913-1.364s-5.8.606-5.913,1.364h-.011v3.787h11.844V39.234h-.011Z",
    transform: "translate(-150.261 -32.935)",
    fill: "#008ef8"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.852 62.734)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.823)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.144,
    height: 9.263,
    transform: "translate(0.48 3.155)",
    fill: "#008ef8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.421,176.337H219.28l.318-2.577h1.5Z",
    transform: "translate(-218.8 -173.76)",
    fill: "#0234c1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.101,
    height: 1.13,
    rx: 0.565,
    transform: "translate(0 2.577)",
    fill: "#0234c1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.924 1.429)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.964,
    height: 8.541,
    transform: "translate(0 2.279) rotate(-15.36)",
    fill: "#ffcd52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.579,178.474l-.643-.754-.166.978c.123-.029.263-.061.408-.1s.282-.079.4-.119Z",
    transform: "translate(-207.546 -177.72)",
    fill: "#6d345b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.15,181.337l1.9-.52-.859-1.007c-.123.04-.256.079-.4.119s-.285.076-.408.1l-.224,1.307Z",
    transform: "translate(-207.15 -179.056)",
    fill: "#c9b095"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.524,198.673h-7.032l-1.9-10.353h10.833Z",
    transform: "translate(-204.59 -183.064)",
    fill: "#b16de2"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEligibleScholarships);
export default __webpack_public_path__ + "static/media/eligible-scholarships.bb6f64d10c293b702010428ebd31c8c8.svg";
export { ForwardRef as ReactComponent };